import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaExcludedPartner } from 'src/app/assabil-sales/models/dtos/geo-area-excluded-partner';

@Component({
  selector: 'geo-area-excluded-partner',
  templateUrl: './geo-area-excluded-partner.component.html',
  styleUrls: ['./geo-area-excluded-partner.component.scss']
})
export class GeoAreaExcludedPartnerComponent implements OnInit {


  @Input() geoAreaExcludedPartner : GeoAreaExcludedPartner;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaExcludedPartner.expanded = !this.geoAreaExcludedPartner.expanded;
  }
}